import type { IconSvgObject } from './types';

const UnfoldLessIcon: IconSvgObject = [
  ["path", { d: "M6 4.5L12 10L18 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 19.5L12 14L18 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UnfoldLessIcon;
